import * as vp from 'vopay';
import { FunctionComponent } from 'react';

import { useNavMenu } from '../../../providers/NavMenu.provider';
import { useHistory } from 'react-router-dom';

import styles from './LearningCenter.module.scss';
import { useTranslation } from 'react-i18next';

type FC = FunctionComponent;

const { Box, Title, Icon } = vp;
const cn = vp.withStyles(styles);

const LearningCenterContainer: FC = () => {
  const history = useHistory();
  const { getModuleTitle } = useNavMenu();
  const { t } = useTranslation('translations', { keyPrefix: 'LearningCenter' });
  const environment = import.meta.env.VITE_APP_ENV;
  return (
    <Box flx="col">
      <Title title={getModuleTitle()} />
      <Box mt="md" lineHeight="25px">
        {t('pageDescription')}
      </Box>
      <div className={cn('cardContainer')}>
        <div
          className={cn('card', 'videoCard', environment === 'staging' && 'inactiveCard')}
          onClick={() => {
            history.push('/learning-centre/video-tutorials/');
          }}
        >
          {environment === 'staging' && <span className={cn('label')}>{t('productionOnlyLabel')}</span>}
          <div className={cn('iconContainer')}>
            <Icon icon="video" color="none" width="50px" height="50px" />
          </div>
          <h4>{t('videoTutorialsTitle')}</h4>
        </div>
        <div
          className={cn('card', 'pdfCard', environment === 'staging' && 'inactiveCard')}
          onClick={() => {
            history.push('/learning-centre/pdf-guide/');
          }}
        >
          {environment === 'staging' && <span className={cn('label')}>{t('productionOnlyLabel')}</span>}
          <div className={cn('iconContainer')}>
            <Icon icon="pdfActive" color="none" width="50px" height="50px" />
          </div>
          <h4>{t('pdfGuideTitle')}</h4>
        </div>
        <div className={cn('card')}>
          <span className={cn('label')}>{t('comingSoonLabel')}</span>
          <div className={cn('iconContainer')}>
            <Icon icon="faq2" color="none" width="50px" height="50px" />
          </div>
          <h4>{t('faqTitle')}</h4>
        </div>
      </div>
    </Box>
  );
};

export default LearningCenterContainer;
